/**
 * @generated SignedSource<<4213440fc0062500728439837680e2e7>>
 * @relayHash b59e33bd39f931ebd97b4179e93b3e29
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b59e33bd39f931ebd97b4179e93b3e29

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HtmlTag = "HTML";
export type ChangeTextDetailsInput = {
  answer?: string | null;
  bodyItemId: string;
  clientMutationId?: string | null;
  prompt?: HtmlInput | null;
  updateAnswer?: boolean | null;
  updatePrompt?: boolean | null;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type TextChangeMutation$variables = {
  input: ChangeTextDetailsInput;
};
export type TextChangeMutation$data = {
  readonly changeTextDetails: {
    readonly bodyItem: {
      readonly answer: any | null;
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type TextChangeMutation = {
  response: TextChangeMutation$data;
  variables: TextChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeTextDetailsPayload",
    "kind": "LinkedField",
    "name": "changeTextDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TextChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TextChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b59e33bd39f931ebd97b4179e93b3e29",
    "metadata": {},
    "name": "TextChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6cb1dc4d81fcd4c562e833fc6f36ece5";

export default node;
